/**
 * Fetches organization info and user auth token from local storage and builds
 * the headers object to be used to authenticate outgoing request to videopeel-web-api
 * @return {Object} organization-identification (if that exists in local storage as well).
 */
function buildHeaders() {
  const organizationId = localStorage && localStorage.getItem('Organization-Identification');
  const headers = {
    'Content-Type': 'application/json'
  };

  if (organizationId && organizationId !== 'null') {
    headers['Organization-Identification'] = organizationId;
  }

  return headers;
}

module.exports = { buildHeaders };



// WEBPACK FOOTER //
// ./src/redux/buildAuthHeader.js